import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';

export default function B2BHeader() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isMenuOpen]);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  return (
    <header className="sticky top-[30px] z-40 w-full bg-surface/90 backdrop-blur-md border-b border-line relative max-w-[100vw] overflow-x-hidden">
      <div className="max-w-[1280px] mx-auto px-4 md:px-16 h-[72px] md:h-[78px] flex items-center justify-between relative z-50 bg-transparent">
        <div className="flex items-center flex-shrink-0 min-w-0">
          <Link to="/" className="block focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand rounded-[10px] p-1 -ml-1">
            <Logo variant="dark" />
          </Link>
        </div>
        
        <nav className="hidden md:flex items-center space-x-4 lg:space-x-6">
          <Link to="/" className={`text-[13px] font-medium tracking-wide uppercase transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand rounded-xl px-3 py-2 ${isActive('/') ? 'text-brand font-bold border border-brand/30 bg-brand/5' : 'text-ink-soft hover:text-brand hover:bg-brand/5'}`}>Inicio</Link>
          <Link to="/bac" className={`text-[13px] font-medium tracking-wide uppercase transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand rounded-xl px-3 py-2 ${isActive('/bac') ? 'text-brand font-bold border border-brand/30 bg-brand/5' : 'text-ink-soft hover:text-brand hover:bg-brand/5'}`}>BAC</Link>
          <Link to="/resultados" className={`text-[13px] font-medium tracking-wide uppercase transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand rounded-xl px-3 py-2 ${isActive('/resultados') ? 'text-brand font-bold border border-brand/30 bg-brand/5' : 'text-ink-soft hover:text-brand hover:bg-brand/5'}`}>Resultados</Link>
          <Link to="/implementacion" className={`text-[13px] font-medium tracking-wide uppercase transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand rounded-xl px-3 py-2 ${isActive('/implementacion') ? 'text-brand font-bold border border-brand/30 bg-brand/5' : 'text-ink-soft hover:text-brand hover:bg-brand/5'}`}>Implementación</Link>
        </nav>

        <div className="flex items-center gap-1.5 md:gap-4 flex-shrink-0">
          <a href="/#contacto" className="inline-flex items-center bg-brand text-white px-4 md:px-6 py-2.5 md:py-3 text-[12px] md:text-[13px] font-semibold tracking-wide hover:bg-brand-deep hover:text-white transition-colors shadow-sm hover:shadow-md rounded-xl uppercase focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand whitespace-nowrap">
            CONVERSEMOS
          </a>
          <button 
            className="md:hidden p-1.5 text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand rounded-xl -mr-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-expanded={isMenuOpen}
            aria-controls="mobile-menu"
            aria-label={isMenuOpen ? "Cerrar menú" : "Abrir menú"}
          >
            {isMenuOpen ? (
              <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            ) : (
              <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="4" x2="20" y1="12" y2="12"/><line x1="4" x2="20" y1="6" y2="6"/><line x1="4" x2="20" y1="18" y2="18"/></svg>
            )}
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div id="mobile-menu" className="md:hidden absolute top-[78px] left-0 w-full bg-surface border-b border-line shadow-sm z-40">
          <nav className="flex flex-col px-6 py-6 space-y-6">
            <Link to="/" className={`text-[14px] font-medium tracking-wide uppercase focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand rounded-xl px-3 py-2 ${isActive('/') ? 'text-brand font-bold border-l-2 border-brand pl-3 bg-brand/5' : 'text-ink-soft'}`}>Inicio</Link>
            <Link to="/bac" className={`text-[14px] font-medium tracking-wide uppercase focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand rounded-xl px-3 py-2 ${isActive('/bac') ? 'text-brand font-bold border-l-2 border-brand pl-3 bg-brand/5' : 'text-ink-soft'}`}>BAC</Link>
            <Link to="/resultados" className={`text-[14px] font-medium tracking-wide uppercase focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand rounded-xl px-3 py-2 ${isActive('/resultados') ? 'text-brand font-bold border-l-2 border-brand pl-3 bg-brand/5' : 'text-ink-soft'}`}>Resultados</Link>
            <Link to="/implementacion" className={`text-[14px] font-medium tracking-wide uppercase focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand rounded-xl px-3 py-2 ${isActive('/implementacion') ? 'text-brand font-bold border-l-2 border-brand pl-3 bg-brand/5' : 'text-ink-soft'}`}>Implementación</Link>
          </nav>
        </div>
      )}
    </header>
  );
}
